import { ORM } from 'redux-orm';
import Attraction from './Attraction';
import Place from './Place';

const orm = new ORM();
orm.register(Attraction);
orm.register(Place)

export { orm };